import { useQuery } from "@tanstack/react-query";
import { URLS } from "../../../infra/URLS";
import { getArquivos } from "../queries/getArquivos";
import { getTokenUpload } from "../queries/getTokenUpload";

export function useGetArquivos(ClienteId: number) {
  const resultQuery = useQuery(
    [`${URLS.ARQUIVOS_LISTA_API}?ClienteId=${ClienteId}`],
    () => getArquivos(ClienteId)
  );
  return resultQuery;
}

export function useGetArquivoToken(ClienteId: number, Arquivos: string[] | string) {
  let arquivoName = ''

  typeof(Arquivos) === 'object' ?
    arquivoName = Arquivos?.map((a : any) => a.name || a.nome).toString()
  : arquivoName = Arquivos

  const resultQuery = useQuery(
    [`${URLS.ARQUIVOS_UP_TOKEN_API}?ClienteId=${ClienteId}&Arquivo=${arquivoName}`],
    () => getTokenUpload(ClienteId, arquivoName)
  );

  return resultQuery;
}